// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__j-koD","dragIcon":"SortableItem_dragIcon__2RBys","disabled":"SortableItem_disabled__2pH1V"};